export default __webpack_public_path__ + "locales/ru/PreparationPortal.json?hash=1e851fd9a6517ce971d8017c90d38c29";